import * as types from './types';
import { get } from 'lodash';
import { fetchPost } from '../api/fetch';
import { openSnackBar } from '../actions/snackbarAction';
import { logOut } from '../actions/loginActions';
import { getCurrentTimeStamp } from '../api/dateFormat';

export function liveDoubtClassListResponse(response) {
  return {
    type: types.LIVE_DOUBT_CLASS_RESPONSE,
    response
  };
}

export const liveDoubtClassList = async (params, dispatch) => {
  const jwtToken = params;
  const body = {};
  const url = 'api/dc/student/livedoubtlist';
  await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' })
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning'
          })
        );
        return dispatch(logOut());
      }
      data['timestamp'] = getCurrentTimeStamp();
      dispatch(liveDoubtClassListResponse(data));
    });
};

export function liveDoubtClassDetailResponse(response) {
  return {
    type: types.LIVE_DOUBT_CLASS_DETAIL_RESPONSE,
    response
  };
}
export const liveDoubtClassDetail = async (loginData, uniqueCode, dispatch) => {
  const jwtToken = loginData;
  const body = {
    UniqueCode: uniqueCode
  };
  const url = 'api/dc/student/livedoubtplayer';
  return await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' })
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning'
          })
        );
        return dispatch(logOut());
      }
      dispatch(liveDoubtClassDetailResponse(data));
      return data;
    });
};
